import routesDeviceState from '@router/routes/routes-device-state'
import routesInsights from '@router/routes/routes-insights'
import routesActions from '@router/routes/routes-actions'
import routesSettings from '@router/routes/routes-settings'
import routesInteract from '@router/routes/routes-interact'
import routesAuth from '@router/routes/routes-auth'

const baseRoutes = [
  { path: '/index.html', redirect: { name: 'Device State' } },
  { path: '/', redirect: { name: 'Device State' } },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

export default baseRoutes.concat(
  routesSettings,
  routesInteract,
  routesDeviceState,
  routesInsights,
  routesActions,
  routesAuth
)
